export const ServiceUrl = {
  MENU: {
    MEGA_MENU: "v1/site/categorylist/6",
    SMALL_MENU: "/v1/site/categories/",
    SAREE_MENU: "/v1/site/products-by-color",
  },
  CATEGORY: "v1/site/categorylist/7",
  BANNER_IMAGES: "v1/sliders",
  ANNOUNCEMENT: "v1/announcement",
  FILTER_CATEGORY: "v1/site/category/menu",
};
